import { Account } from 'model/IChat';
import React from 'react';
import RoundedAvatar from 'reusable-components/avatars/RoundedAvatar';

const CSS = require('./BookBlockSelectedLocal.module.scss');

interface BookBlockSelectedLocalProps {
  selectedLocal: Partial<Account>;
  hasAvailableSelectedDate: boolean;
  hasAvailableSelectedTime: boolean;
}

function BookBlockSelectedLocal({
  selectedLocal,
  hasAvailableSelectedDate,
  hasAvailableSelectedTime,
}: BookBlockSelectedLocalProps) {
  return (
    <div className={CSS.BookBlockLocals}>
      <figure className={CSS.HostImages}>
        <RoundedAvatar
          image={selectedLocal?.photo}
          size={48}
          height={64}
          thumb
          alt={`image of ${selectedLocal?.firstName}, ${selectedLocal?.personal_title}`}
          color="pink"
          className={CSS.Avatar}
          borderSize={1}
        />
      </figure>
      <div className={CSS.Text}>
        <div className={CSS.Selection}>
          <strong className={CSS.TextLabel}>Your selection</strong>
          {!hasAvailableSelectedDate && (
            <span className={CSS.NotAvailable}>Date not available</span>
          )}
          {hasAvailableSelectedDate && !hasAvailableSelectedTime && (
            <span className={CSS.NotAvailable}>Time not available</span>
          )}
        </div>
        <span className={CSS.LocalName}>{selectedLocal?.firstName}</span>
        <span className={CSS.PersonalTitle}>
          {selectedLocal?.personal_title}
        </span>
      </div>
    </div>
  );
}

export default BookBlockSelectedLocal;
